import MainMenuSkeleton from "./MainMenuSkeleton";

export default MainMenuSkeleton;
